import React, { useCallback } from "react";

import { Box, DialogHeading, IconBox, Inline } from "@compono/ui";
import { AiSolidIcon } from "@compono/ui-icons";
import { ChatComponent } from "~/components/Chat";
import { ChatAction, Message } from "~/components/Chat/ChatComponent";
import { env } from "~/env";

const ChatAgentPage = () => {
  const callAgent = useCallback(
    async (message: string, model?: string, messageHistory?: Message[]) => {
      try {
        const res = await fetch(env.GEN_AI_AGENT_API_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              message,
              model,
              messageHistory: messageHistory
                ? messageHistory.map((msg) => ({
                    text: msg.text,
                    sender: msg.sender,
                    timestamp: msg.timestamp.toISOString(),
                  }))
                : undefined,
            }),
          }
        );

        const data = await res.json();

        if (!res.ok) {
          return `Error: ${data.details}`;
        }
        // The lambda returns { output, steps, toolCacheStats }
        if (data?.output) return data.output as string;
        return JSON.stringify(data);
      } catch (err: unknown) {
        return `Request failed: ${
          err instanceof Error ? err.message : "Unknown error"
        }`;
      }
    },
    []
  );

  const actions: ChatAction[] = [
    {
      label: "Ask about weather today",
      message: "Tell me about the weather today.",
    },
    {
      label: "Ask about META stock price",
      message: "Tell me about META's stock price",
    },
  ];

  const getInitialChatMessages = () => {
    const messages = [
      {
        id: "welcome-1",
        text: "Hi there! I'm your team insights assistant. I can help you understand your team dynamics better.",
        sender: "AI" as const,
        timestamp: new Date(),
      },
      {
        id: "welcome-2",
        text: "Feel free to ask me questions about your team composition, strengths, potential blind spots, or how to improve team collaboration.",
        sender: "AI" as const,
        timestamp: new Date(),
      },
    ];

    return messages;
  };

  return (
    <Box>
      <Box
        sx={{
          background:
            "linear-gradient(#EAF7FF, #EAF7FF) padding-box, linear-gradient(to top, #1268B3, #35C6FF) border-box",
          borderRadius: "6px 6px 0 0 ",
          p: 1,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, display: "flex" }}>
          <Inline gap="2">
            <IconBox icon={AiSolidIcon} sx={{ fontSize: "14px", ml: 3 }} />
            <DialogHeading
              sx={{
                background: "linear-gradient(to left, #1268B3, #35C6FF)",
                backgroundClip: "text",
                color: "transparent",
                fontWeight: 700,
                fontSize: "14px",
                m: 0,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              AI Assist Chat
            </DialogHeading>
          </Inline>
        </Box>
      </Box>
      <Box sx={{ p: 3 }}>
        <ChatComponent
          initialMessages={getInitialChatMessages()}
          onSendMessage={callAgent}
          actions={actions}
          sendMessageHistory={true}
        />
      </Box>
    </Box>
  );
};

export default ChatAgentPage;
